import { Link } from 'react-router';
import { Signature } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DATE_TIME_FORMAT } from '@/lib/dayjs';
import { useAbsencesToSign } from '@/stores/useAbsencesToSign';

const absences = (count: number) => `${count} absence${count > 1 ? 's' : ''}`;

/**
 * Encart en tête de Mes demandes : les absences qui attendent la signature de l'employé, chacune avec « Signer » (vers
 * son détail, où il la signe) ; rien quand il n'y en a pas
 */
export function AbsencesToSignBox() {
  const { sheets, count, memberId } = useAbsencesToSign();
  if (!count || memberId === null) return null;

  return (
    <section
      aria-label="Absences à signer"
      className="mb-6 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900"
    >
      <h3 className="font-semibold">
        {absences(count)} {count > 1 ? 'attendent' : 'attend'} votre signature
      </h3>
      <ul className="mt-3 divide-y divide-amber-200">
        {sheets.map((sheet) => (
          <li
            key={sheet.id}
            className="py-2 flex flex-wrap items-center justify-between gap-3"
            data-testid="absence-to-sign"
          >
            <span>
              Absence de <span className="font-medium">{sheet.period.monthLabel}</span>
              {sheet.submittedAt && <> · déclarée le {sheet.submittedAt.format(DATE_TIME_FORMAT)}</>}
            </span>
            <Button asChild size="sm">
              <Link to={`/requests/${sheet.id}`} aria-label={`Signer l'absence de ${sheet.period.monthLabel}`}>
                <Signature />
                Signer
              </Link>
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
}
